export const arraysMatch = (arr1: unknown[], arr2: unknown[]) => {
  for (let i = 0; i < arr1.length; i += 1) {
    if (!arr2.includes(arr1[i])) return false;
  }
  return true;
};

export const selectValue = (
  value: unknown,
  selected: unknown[],
  all: unknown[]
) => {
  const updated = [...selected, value];
  // As inserting values at predefined index positions doesn't work with empty
  // arrays, we need to reorder the updated selection to match the initial order
  const sorted = updated.sort((a, b) =>
    all.indexOf(a) > all.indexOf(b) ? 1 : -1
  );
  return sorted;
};

export const deselectValue = (value: unknown, selected: unknown[]) =>
  selected.filter(v => v !== value);
